import { getSiteBaseUrl } from '../config/site';

const normalizeSegment = (value) => String(value || '').replace(/^\/+|\/+$/g, '');

export const buildBusinessPath = ({ stateSlug, citySlug, categorySlug, slug }) => {
  const segments = [stateSlug, citySlug];

  if (categorySlug) {
    segments.push(categorySlug);
  }

  if (slug) {
    segments.push(slug);
  }

  const normalizedSegments = segments.map(normalizeSegment).filter(Boolean);
  return normalizedSegments.length > 0 ? `/${normalizedSegments.join('/')}` : '/';
};

export const buildBusinessUrl = (parts, baseUrl = getSiteBaseUrl()) => {
  const normalizedBaseUrl = String(baseUrl || '').replace(/\/$/, '');
  return `${normalizedBaseUrl}${buildBusinessPath(parts)}`;
};

